module.exports = __webpack_public_path__ + "img/W-AS3485023.1fe85add.jpg";